import { render, staticRenderFns } from "./MealsSummary.vue?vue&type=template&id=789b3c28&scoped=true"
import script from "./MealsSummary.vue?vue&type=script&lang=js"
export * from "./MealsSummary.vue?vue&type=script&lang=js"
import style0 from "./MealsSummary.vue?vue&type=style&index=0&id=789b3c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b3c28",
  null
  
)

export default component.exports